import uniqBy from "lodash/uniqBy";

import {Part} from "../part";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {PartMenuType} from "../../../visComponents/constants";
import {floorThumbnail} from "../assets";

import {IntermediatePart} from "../intermediatePart";

export default class Floor extends Part {
  static id = 'Floor';

  constructor() {
    super(true, false, PartMenuType.Complex);
    this.partId = 'kitchen_floor';
    this.menuType = PartMenuType.Complex;
    this.partName = 'Floor';
    this.homePageTitle = 'Flooring';
    this.translateId = "visualizer.kitchen.kitchen_floor";
    this.partThumbnail = floorThumbnail;
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Floor":
        relatedItemName = "floorBody";
        RelatedItemClass = FloorBody;
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        if (relatedItemName !== "shadows") {
          this.relatedItems.push(this[relatedItemName]);
        }
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  navigationItem() {
    return new DesignNavigationItem('Floor', this)
  }
}

class FloorBody extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.isStoneFeature = true;
    this.partId = 'kitchen_floor';
    this.partName = 'Floor';
    this.translateId = "visualizer.kitchen.kitchen_floor";
  }

  load(dbFeature) {
    return super.load_(dbFeature, new FloorBody());
  }

  navigationSubItems(filters, searchText) {
    const navSubItems = this.getFeaturesBySearchText(this.getFilteredFeaturesByFilters(filters), searchText)
      .map(_ => new DesignNavigationItem(_.featureName, _)); // 1) filter them by filters 2) filter them by search
    return uniqBy(navSubItems, (navItem) => navItem.part.dbFeature.sharedFeatureName)
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Floor;
    }
  }
}
